import { render, staticRenderFns } from "./CommercialProductEdit.vue?vue&type=template&id=5d584fc8&scoped=true&"
import script from "./CommercialProductEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d584fc8",
  null
  
)

export default component.exports